import React from 'react';
import { Box } from '../../legacy/Box';
import { Flex } from '../../legacy/Flex';
import { identifyComponent } from '../../util';
import { Option, RadioOption } from '../RadioOption';

interface RadioGroupProps<T extends Option> {
  selected: T;
  options: T[];
  onChange: (value: T) => void;
  name: string;
  direction?: 'row' | 'column';
  disabled?: boolean;
  testId?: string;
}

export function RadioGroup<T extends Option>(props: RadioGroupProps<T>): React.ReactElement {
  const {
    selected,
    options,
    onChange,
    name,
    direction = 'column',
    disabled,
    testId = 'radio-group',
    ...rest
  } = props;
  return (
    <Flex
      data-component="RadioGroup"
      column={direction === 'column'}
      alignItems="flex-start"
      justifyContent="flex-start"
      testId={testId}
      {...rest}
      {...identifyComponent('radio-group', rest)}
    >
      {options.map((opt, idx) => {
        const marginBottom: React.ComponentProps<typeof Box>['marginBottom'] =
          idx == options.length - 1 ? 0 : 8;
        const marginRight: React.ComponentProps<typeof Box>['marginRight'] =
          idx == options.length - 1 ? 0 : 16;
        const marginProps = direction === 'column' ? { marginBottom } : { marginRight };
        return (
          <Box key={opt.id} testId={opt.id} {...marginProps}>
            <RadioOption<T>
              option={opt}
              name={name}
              onChange={onChange}
              checked={selected && opt.id === selected.id}
              disabled={disabled}
            />
          </Box>
        );
      })}
    </Flex>
  );
}
